import React from 'react';
import get from 'lodash/get';
import MessagesComponent from 'components/Messages/Messages';
import NewMessageContainer from '../../containers/NewMessageContainer';
import InboxButtonContainer from '../../containers/tools/InboxButtonContainer';
import ResolveConfirmPopup from '../popups/ResolveConfirmPopup';
import showExpertReviewPopup from '../popups/ExpertReviewPopup';
import { disabledResolveConversationStates } from '../../constants/conversationTypes';
import { createPopup, closePopup } from '../../services/popupService';
import { trackButtonClick, BUTTONS } from '../../analytics/buttonEventAnalytics';
import { escalationRecosDisplayed } from '../../analytics/mlEventAnalytics';
import { trackEscalationClickBasedOnAlert } from '../../analytics/searchEventAnalytics';
import InboxTabPickerContainer from '../../containers/inboxPanel/InboxTabPickerContainer';
import {
  ActionsButtonsWrapper,
  NoButtonPlaceholder,
  EscalatedActionButtonHolder,
  InboxButtonWrapper,
} from '../common/buttonsComponents';
import Loading from '../LoadingComponent/LoadingComponent';
import TicketButton from '../Buttons/TicketButton/TicketButton';
import * as messageDirection from '../../constants/messageDirection';
import { showErrorPopup } from '../popups/ErrorPopup/ErrorPopup';
import { getAccountBrandConfigValue } from '../../util';
import { showErrorMessage } from '../../util/errorPopupUtil';
import { ENROUTE, DELIVERED, SOURCE_TYPE_SIMPLR, SOURCE_TYPE_SIMPLR_BOT } from 'constants/messageStatuses';
import SelectedMessage from '../Messages/SelectedMessage/SelectedMessage';
import { ErrorStrings } from '../../constants/fixedMessages';
import { closePopupByIdOrType } from 'services/popupService';
import EscalationRecommendationPopup from '../popups/EscalationRecommendationPopup';
import { getGlobalParseConfigsList } from '../../api/platformConfig';
import { Section, SplitSections, LoadingContainer, ChatHolder, MessagesGroups } from './AssignedTicketComponent.styles';
import * as SessionAnalyticsService from 'services/SessionAnalyticsService/SessionAnalyticsService';
import { SHOW_EMAIL_TO_EXPERTS, IS_SHOW_EMAIL_TO_EXPERTS } from 'constants/extraBusinessInfo';

export class AssignedTicketComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textAreaExpanded: false,
      previousConversationsDisabledAccounts: [],
    };
    this.forceUpdateWrapper = () => this.forceUpdate();
  }

  async componentDidUpdate(prevProps) {
    const { ticket: prevSelectedTicket } = prevProps.selectedTicket;
    const { ticket: selectedTicket } = this.props.selectedTicket;

    if (selectedTicket && prevSelectedTicket) {
      if (selectedTicket.ticketId !== prevSelectedTicket.ticketId) {
        // if ticket has been switched, collapse dropdown
        this.setState({ textAreaExpanded: false });
      }
      const previousConversationsDisabledAccounts = this.state.previousConversationsDisabledAccounts;
      if (
        Array.isArray(previousConversationsDisabledAccounts) &&
        !previousConversationsDisabledAccounts.includes(selectedTicket.simplrAccountPtrId)
      ) {
        this.props.openPreviousConversationsSection();
      }
    }

    const oldTicketId = get(prevProps, 'selectedTicket.ticket.ticketId', null);
    const newTicketId = get(this.props, 'selectedTicket.ticket.ticketId', null);

    if (oldTicketId !== newTicketId && this.props.activeEscRecoPopupId) {
      closePopupByIdOrType(this.props.activeEscRecoPopupId);
      this.props.setActiveEscRecoPopupId(null);
    }
  }

  async componentDidMount() {
    const { clearHistoricalTicket, setChatMacroRecommendationsEnabled } = this.props;
    const { previousConversationsDisabledAccounts } = await getGlobalParseConfigsList([
      'previousConversationsDisabledAccounts',
    ]);
    this.setState({
      previousConversationsDisabledAccounts: previousConversationsDisabledAccounts,
    });
    clearHistoricalTicket();
    setChatMacroRecommendationsEnabled(true);
  }

  onExpandClick = () => {
    this.setState({
      textAreaExpanded: !this.state.textAreaExpanded,
    });
  };

  /*  Called when user clicks/types in the message form
          Checks whether to show Escalation Recommendation
          Criteria to show Escalation Reco popup:
            - ticket's conversationType is email
            - expert has not already seen this tickets escalation recommendation popup
            - response from ml endpoint includes toDisplay === true
      */
  handleEscalationRecommendation = async () => {
    // get values from escRecoData
    const escRecoData = this.props.escalationRecommendationMessage;
    const currentTicketSMBName = this.props.currentTicketSMBName;

    if (!currentTicketSMBName || !escRecoData) {
      return;
    }

    const ticket = this.props.ticket;

    if (ticket && escRecoData && escRecoData.title && escRecoData.alertId) {
      const escRecoPopupId = EscalationRecommendationPopup({
        currentTicketSMBName,
        alertTitle: escRecoData.title,
        onConfirm: () => {
          const { assignedTicketsIds } = this.props;
          if (Array.isArray(assignedTicketsIds) && assignedTicketsIds.includes(ticket.ticketId)) {
            this.props.handleEscalationPopup(ticket, null, true);
            trackEscalationClickBasedOnAlert(escRecoData.alertId);
          }
        },
      });

      this.props.setEscRecoSeen(ticket);
      this.props.setActiveEscRecoPopupId(escRecoPopupId);
      escalationRecosDisplayed(escRecoData.alertId);
    }
  };

  handleEscalateClick() {
    const {
      selectedTicket: { ticket },
      isAdmin,
    } = this.props;

    if (ticket.escalatedForReview && !isAdmin) {
      const { expertReviewEscalation } = this.props;
      showExpertReviewPopup({
        expertReviewEscalationAction: expertReviewEscalation,
        expertReviewResolveAction: null,
        selectedTicket: ticket,
      });
    } else {
      this.props.handleEscalationPopup(ticket);
    }
  }

  handleResolveClick() {
    const { selectedTicket, onMarkAsResolved, allMessages, isAdmin, isSpecialistLite } = this.props;

    if (!selectedTicket || !selectedTicket.ticket) {
      showErrorMessage(new Error(ErrorStrings.SELECTED_TICKET_NOT_FOUND), true);

      return;
    }

    /*
              Ticket is considered answered if all are true (with/out INTERNAL_NOTE ):
              1. there is no inbound message after the last outbound message
              2. last outbound message was successfully sent
            */
    const isTicketAnswered = (allMessagesInConversation) => {
      let lastInboundMessageIndex = 0; // first message is always an inbound message so initalizing with 0
      let lastOutboundMessageIndex;

      allMessagesInConversation.forEach((message, index) => {
        if (message.direction === messageDirection.INBOUND) {
          lastInboundMessageIndex = index;
        } else if (
          message.direction === messageDirection.OUTBOUND &&
          [SOURCE_TYPE_SIMPLR, SOURCE_TYPE_SIMPLR_BOT].includes(message.source)
        ) {
          lastOutboundMessageIndex = index;
        }
      });

      // if there is no outbound message then the ticket is considered as unanswered
      if (!lastOutboundMessageIndex) {
        return false;
      }

      if (lastOutboundMessageIndex > lastInboundMessageIndex) {
        // ticket is answered if the last message has been delivered
        const lastMessageDelivered = [ENROUTE, DELIVERED].includes(
          allMessagesInConversation[lastOutboundMessageIndex].status
        );

        return lastMessageDelivered;
      }

      return false;
    };

    if (!isTicketAnswered(allMessages) && (!isAdmin || isSpecialistLite)) {
      return showErrorPopup(
        `This conversation contains customer messages that have not been replied to. You must reply to all customer messages before resolving this conversation.`,
        'Oops!'
      );
    } else if (!isAdmin && selectedTicket.ticket.escalatedForReview) {
      const { ticket } = selectedTicket;
      showExpertReviewPopup({
        expertReviewEscalationAction: null,
        expertReviewResolveAction: onMarkAsResolved,
        selectedTicket: ticket,
      });
    } else {
      createPopup({
        type: 'ResolveConfirmPopup',
        title: null,
        content: <ResolveConfirmPopup />,
        noOverlay: false,
        buttons: {
          right: [
            {
              text: 'DISMISS',
              className: 'dismiss',
              action: () => closePopup(),
            },
            {
              text: 'RESOLVE',
              className: 'confirm',
              action: async () => {
                closePopup();
                SessionAnalyticsService.event('Expert Resolved Ticket', {
                  ticketDetails: selectedTicket.ticket,
                  ticket: selectedTicket.ticket.ticketId,
                });

                return onMarkAsResolved(selectedTicket.ticket.ticketId);
              },
            },
          ],
        },
      });
    }
  }

  getTextAreaMinSize = () => {
    const { isCommerceWizardActive, chatUIStatus } = this.props;

    if (isCommerceWizardActive) {
      // chat recommendations are disabled when blue warning is shown
      return 272;
    } else if (chatUIStatus) {
      return chatUIStatus.isOpen ? 300 : 200;
    }

    return 200;
  };

  getSplitSectionsConfigs = (showButtons, isSelectedHistoricalTicket, textAreaExpanded) => {
    let sizes = null;
    let minSizes = null;
    let gutterSize = 1;

    const textAreaMinSize = this.getTextAreaMinSize();

    if (!showButtons || isSelectedHistoricalTicket) {
      // when historical ticket selected -> show messages, hide textarea
      sizes = [100, 0];
      minSizes = [100, 0];
      gutterSize = 0;
    } else if (textAreaExpanded) {
      // if textarea is expanded -> collapse messages, textarea full height
      sizes = [0, 100];
      minSizes = [0, textAreaMinSize];
    } else {
      // default -> messages 80%, textarea 20% of height
      // size cannot be smaller than minSize
      sizes = [80, 20];
      minSizes = [0, textAreaMinSize];
    }

    return { sizes, minSizes, gutterSize };
  };

  // updates textAreaExpanded flag if manually resized message box to max / less than max height
  onDragEnd = (sizes) => {
    if (!Array.isArray(sizes)) {
      return;
    }

    let textAreaExpanded;

    if (sizes[1] > 99) {
      textAreaExpanded = true;
    } else {
      textAreaExpanded = false;
    }

    this.setState({ textAreaExpanded });
  };

  render() {
    const {
      isAdmin,
      selectedTicket,
      general,
      setShowTools,
      outboundMessageCount,
      showButtons,
      businessDetailsForTicket,
      isSelectedHistoricalTicket,
      selectedConversation,
      ticketRemovalInProcess,
      isExpertDashboardOpened,
    } = this.props;

    if (!selectedTicket) {
      showErrorMessage(new Error(ErrorStrings.SELECTED_TICKET_NOT_FOUND), true);

      return null;
    }

    const showOrHide =
      selectedTicket.selectedInboxTab === 'assigned' || selectedTicket.selectedInboxTab === 'live_chat' ? '' : 'hide';
    const showResolveButton = isAdmin || outboundMessageCount > 0;

    const ticketsAvailable = this.props.queueLength !== 0;

    const showEmailToExperts = getAccountBrandConfigValue(
      businessDetailsForTicket,
      SHOW_EMAIL_TO_EXPERTS,
      selectedTicket.ticket.brand,
      IS_SHOW_EMAIL_TO_EXPERTS
    );
    const showNewMessagesContainer = !isSelectedHistoricalTicket && showButtons;
    const splitSectionsConfigs = this.getSplitSectionsConfigs(
      showButtons,
      isSelectedHistoricalTicket,
      this.state.textAreaExpanded
    );

    const ticketType = selectedTicket.ticket.ticketType;
    const isDisabledResolveConversationStates = disabledResolveConversationStates.includes(ticketType);

    return (
      <ChatHolder className={'full-height ' + showOrHide} name="assigned-ticket-component">
        {!isExpertDashboardOpened ? (
          <EscalatedActionButtonHolder>
            {general.showTools && (
              <InboxButtonWrapper removePadding={!isAdmin}>
                <InboxButtonContainer />
                {!isAdmin && <InboxTabPickerContainer />}
              </InboxButtonWrapper>
            )}
            {showButtons && !isSelectedHistoricalTicket && (
              <ActionsButtonsWrapper>
                {!general.showTools && (
                  <TicketButton
                    label="ACTIONS"
                    onClick={() => {
                      setShowTools(!general.showTools);
                      trackButtonClick(BUTTONS.ACTIONS);
                    }}
                    active={true}
                  />
                )}
                {isDisabledResolveConversationStates ? (
                  <TicketButton
                    label="RESOLVE"
                    active={false}
                    disabled={true}
                    title="This ticket cannot be resolved. It will be removed from your queue for you."
                  />
                ) : (
                  <TicketButton
                    label="RESOLVE"
                    className={showResolveButton ? '' : 'hide'}
                    active={true}
                    onClick={() => this.handleResolveClick()}
                  />
                )}
              </ActionsButtonsWrapper>
            )}
          </EscalatedActionButtonHolder>
        ) : (
          <NoButtonPlaceholder />
        )}
        <SelectedMessage
          isAdmin={isAdmin}
          ticket={selectedTicket.ticket}
          showEmailToExperts={showEmailToExperts}
          conversation={selectedConversation}
          isHistoricalTicket={this.props.isHistoricalTicket}
        />
        <MessagesGroups name="MessagesGroups">
          {ticketsAvailable && !ticketRemovalInProcess ? (
            <SplitSections
              sizes={splitSectionsConfigs.sizes}
              minSize={splitSectionsConfigs.minSizes}
              gutterSize={splitSectionsConfigs.gutterSize}
              dragInterval={1}
              direction="vertical"
              cursor="row-resize"
              onDragEnd={this.onDragEnd}
              $chatUIOnscreen={get(this.props.chatUIStatus, 'isOnscreen', false)}
            >
              <Section>
                <MessagesComponent />
              </Section>
              {showNewMessagesContainer && (
                <Section>
                  <NewMessageContainer
                    textAreaExpanded={this.state.textAreaExpanded}
                    onExpandClick={this.onExpandClick}
                    handleEscalationRecommendation={this.handleEscalationRecommendation}
                  />
                </Section>
              )}
            </SplitSections>
          ) : (
            <LoadingContainer>
              <Loading delay={100} marginTop={'0px'} />
            </LoadingContainer>
          )}
        </MessagesGroups>
      </ChatHolder>
    );
  }
}

export default AssignedTicketComponent;
